import { Component, Input, OnInit } from '@angular/core';
import { UsefulLink } from '../../../shared/interfaces/useful-link';
import { links } from '../useful-links';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-exams-list-card',
  templateUrl: './exams-list-card.component.html',
  styleUrls: ['./exams-list-card.component.scss']
})
export class ExamsListCardComponent implements OnInit {
  constructor(private iconService: IconService) {}

  usefulLinks: UsefulLink[] = links;
  blockData: any;
  @Input() set pageData(value: any) {
    if (value) {
      if (value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
      } else {
        value.icon = 'exams';
      }
      this.blockData = value;
    }
  }

  ngOnInit(): void {
    this.usefulLinks = this.blockData.usefullLinks.map((link: any) => {
      return {
        link: link.url,
        text: link.title
      };
    });
  }
}
